export default "__VITE_ASSET__DBLtvgPV__"